import React, { useState } from "react";
import Filter from './components/Filter';
import Banner from "../../components/Banner";
import Breadcrumb from './components/Breadcrumb';
import MediaContent from './components/MediaContent';
import useFetch from "../../commons/useFetch";
function Media(){
    const [service, setService] = useState();
    const [province, setProvince] = useState();
    const { data: Medias } = useFetch('https://my-json-server.typicode.com/hongngat/db-smarthotel-booking/Medias/');
    function onChangeService(value) {
      setService(value);
    }
    function onchangeProvince(value) {
      setProvince(value);
    }
    
    return (
      <>
      <Banner />
          <Breadcrumb />
          <Filter onChangeService={onChangeService} onchangeProvince={onchangeProvince}/>
          <MediaContent service={service} province={province} Medias={Medias}/>
      </>
    );
}
export default Media;